module.exports = __webpack_public_path__ + "img/tree-02-b-leaves.f374fb23.png";